
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ShDragDataDirective } from '../../directives/drag-data/drag-data.directive';
import { ShMediaPlaceholderComponent } from '../media-placeholder/media-placeholder.component';

@Component({
    standalone: true,
    selector: 'sh-media-block',
    templateUrl: './media-block.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShMediaPlaceholderComponent, ShDragDataDirective]
})
export class ShMediaBlockComponent {
    @Input() imgSrc!: string;
    @Input() imgAlt!: string;
    @Input() dragString?: string;
    @Input() processing?: boolean = false;
    @Input() previewError?: boolean = false;
    @Input() previewMessage?: string;
}
